/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-unused-vars */
import { CircleAlert, SquarePen, Plus, Trash2 } from 'lucide-react'
import { Formik } from 'formik'
import { useCallback, useEffect, useRef, useState } from 'react'
import {
  Badge,
  Button,
  Card,
  Col,
  Container,
  Form,
  OverlayTrigger,
  Popover,
  Row,
  Spinner,
  Table
} from 'react-bootstrap'
import { AsyncTypeahead } from 'react-bootstrap-typeahead'
import { useLocation, useNavigate, useParams } from 'react-router-dom'
import Swal from 'sweetalert2'
import { useDebouncedCallback } from 'use-debounce'
import BreadCrumb from '../../../components/Label/Breadcrumb'
import Loader from '../../../components/atoms/Loader'
import CustomButton from '../../../components/Button/CustomButton'
import DatePickerComponent from '../../../components/Input/DatePicker'
import ModalAddBatch from '../../../components/modal/batch/ModalAddBatch'
import ModalAddCategoryItem from '../../../components/modal/items/ModalAddCategoryItem'
import ModalUpdateItemCoaPrDraft from '../../../components/modal/pr/ModalUpdateItemCoaPrDraft'
import ModalUpdateVehiclePrDraft from '../../../components/modal/pr/ModalUpdateVehiclePrDraft'
import api from '../../../config/AxiosInstance'
import {
  capitalizeWords,
  convertDateWithoutTime,
  convertDateWithTime,
  transformKey
} from '../../../helpers/constants'
import * as Common from '../../../utils/Common'
import Select from 'react-select'
import {
  PurchaseReceiptCreateImportSchema,
  PurchaseReceiptCreateLocalSchema
} from '../../../utils/validationSchema'
import Loading from '../../../components/atoms/Loading'
import ModalCheckSuggest from '../../../components/modal/Inbound/ModalCheckSuggest'
import { useMemo } from 'react'

const cardStyle = {
  border: 'none',
  boxShadow: '0 2px 12px rgba(0,0,0,0.04)',
  borderRadius: '12px',
  padding: '1.5rem',
  marginBottom: '1.5rem',
  backgroundColor: '#fff'
}

const labelDetailStyle = {
  fontSize: '0.75rem',
  fontWeight: '700',
  color: '#999',
  textTransform: 'uppercase',
  marginBottom: '0.25rem',
  letterSpacing: '0.5px'
}

const tableHeaderStyle = {
  fontSize: '14px',
  fontWeight: '600',
  color: '#333333',
  letterSpacing: '0.5px',
  backgroundColor: '#f8f9fa',
  borderBottom: '2px solid #e9ecef'
}

const StyledTextField = ({
  label,
  value,
  name,
  handleChange,
  handleBlur,
  touched,
  errors,
  type = 'text',
  placeholder,
  required,
  disabled,
  as,
  col = 12
}) => {
  return (
    <Form.Group className={`mb-3 col-12 col-md-${col}`}>
      <Form.Label style={labelDetailStyle}>
        {label} {required && <sup className="text-danger">*</sup>}
      </Form.Label>
      <Form.Control
        as={as}
        type={type}
        name={name}
        value={value}
        onChange={handleChange}
        onBlur={handleBlur}
        isInvalid={touched?.[name] && !!errors?.[name]}
        placeholder={placeholder}
        disabled={disabled}
        className={`px-3 ${disabled ? 'bg-light' : 'bg-white'}`}
        style={{
          fontSize: '0.9rem',
          height: as === 'textarea' ? 'auto' : '40px',
          borderRadius: '8px',
          border: '1px solid #ced4da'
        }}
        autoComplete="off"
      />
      <Form.Control.Feedback type="invalid">
        {errors?.[name]}
      </Form.Control.Feedback>
    </Form.Group>
  )
}

const StyledSelectInput = ({
  label,
  value,
  name,
  handleChange,
  handleBlur,
  touched,
  errors,
  options,
  required,
  disabled,
  col = 12,
  placeholder,
  hasData,
  reff
}) => {
  return (
    <Form.Group className={`mb-3 col-12 col-md-${col}`}>
      <Form.Label style={labelDetailStyle}>
        {label} {required && <sup className="text-danger">*</sup>}
      </Form.Label>
      <Form.Select
        name={name}
        ref={reff}
        value={value}
        onChange={handleChange}
        onBlur={handleBlur}
        isInvalid={touched?.[name] && !!errors?.[name]}
        disabled={disabled}
        className={`px-3 ${disabled ? 'bg-light' : 'bg-white'}`}
        style={{
          fontSize: '0.9rem',
          height: '40px',
          borderRadius: '8px',
          border: '1px solid #ced4da'
        }}
      >
        <option value="">{placeholder || 'Select'}</option>
        {options.map((option, idx) => (
          <option
            key={idx}
            value={option.id || option.value}
            hasData={option.hasData || option.has_category}
          >
            {option.name || option.item_name || option.label}
          </option>
        ))}
      </Form.Select>
      <Form.Control.Feedback type="invalid">
        {errors?.[name]}
      </Form.Control.Feedback>
    </Form.Group>
  )
}

const btnOrange = {
  backgroundColor: 'var(--primary-orange)',
  borderColor: 'var(--primary-orange)',
  color: 'white'
}

const FILE_SIZE = 5000 * 1024 // 5MB in bytes

const uploadFileViaPresignedUrl = async (fileObj) => {
  const formData = new FormData()
  formData.append('file', fileObj)
  formData.append('module', 'inbound')

  const res = await api.post('/upload/temp-file', formData, {
    headers: { 'Content-Type': 'multipart/form-data' }
  })

  return { tempPath: res.data.data.tempPath, fileName: fileObj.name || 'file' }
}

const PurchaseReceiptCreate = () => {
  const location = useLocation()
  const [poData, setPoData] = useState({})
  const uploadFileAttachment = useRef(null)
  const navigate = useNavigate()
  const [isLoadingPage, setIsLoadingPage] = useState(false)
  const [isDragging, setIsDragging] = useState(false)
  const [areaOptions, setAreaOptions] = useState([])
  const [modalUpdateShow, setModalUpdateShow] = useState(false)
  const [modalAddBatch, setModalAddBatch] = useState(false)
  const [modalAddCategory, setModalAddCategory] = useState(false)
  const [modalUpdateItemShow, setModalUpdateItemShow] = useState(false)
  const [attachments, setAttachments] = useState([])
  const [uploadingAttachment, setUploadingAttachment] = useState(false)
  const pr_type = location.state.type
  const method = location.state.methodValue
  const [vehicles, setVehicles] = useState([])
  const [selectedVehicle, setSelectedVehicle] = useState(0)
  const [selectedWarehouse, setSelectedWarehouse] = useState('')
  const refSrcWarehouses = useRef()
  const refSeriesNumber = useRef()
  const [itemCoas, setItemCoas] = useState([])
  const [selectedItemCoa, setSelectedItemCoa] = useState(0)
  const [items, setItems] = useState([])
  const [inputBatch, setInputBatch] = useState('')
  const [batchId, setBatchId] = useState(0)
  const [batchSelectedDetail, setBatchSelectedDetail] = useState(null)
  const [itemId, setItemId] = useState(0)
  const [options, setOptions] = useState([])
  const [newOption, setNewOption] = useState(null)
  const [selectItem, setSelectItem] = useState({})
  const [dataItemSelect, setDataItemSelect] = useState()
  const [warehouses, setWarehouses] = useState([])
  const [dataWarehouses, setDataWarehouses] = useState([])
  const [locationAll, setLocationAll] = useState([])
  const [selectedBranch, setSelectedBranch] = useState('')
  const [typeWarehouseExternal, setTypeWarehouseExternal] = useState(null)
  const [itemCoaIdValue, setItemCoaIdValue] = useState(null)
  const [totalPack, setTotalPack] = useState({
    total_qty: 0,
    conversion_uom: '',
    conversion_qty_uom: '',
    conversion_factor: ''
  })
  const [uomOptions, setUomOptions] = useState([])
  const [selectedUom, setSelectedUom] = useState(null)
  const [isLoading, setIsLoading] = useState(false)
  const [series, setSeries] = useState([])
  const [listItemsId, setListItemsId] = useState({})
  const [simDocFile, setSimDocFile] = useState(false)
  const [stnkDocFile, setStnkDocFile] = useState(false)
  const [coaDocFile, setCoaDocFile] = useState(false)
  const [loadingArea, setLoadingArea] = useState(false)
  const { code } = useParams()
  const [suggest, setSuggest] = useState({
    show: false,
    hasSuggest: true,
    itemCodes: []
  })

  const loadData = async () => {
    try {
      setIsLoadingPage(true)
      const res = await api.get(`inbound/purchase-order/show?po=${code}`)
      const resSuggest = await api.get(
        `inbound/pr-draft/check-suggest?po=${code}`
      )
      const resBranch = await api.get('/master/locations/all')

      const { status: statusSuggest, data: dataSuggest } = resSuggest
      if (statusSuggest === 200) {
        const { data: dataResponseSuggest } = dataSuggest
        setSuggest({
          show: !dataResponseSuggest.has_suggest ? true : false,
          hasSuggest: dataResponseSuggest.has_suggest,
          itemCodes: dataResponseSuggest.item_codes
        })
      }

      if (resBranch.status === 200) {
        const optionData = resBranch.data.data.reduce((acc, data) => {
          acc.push({ value: data.area_name, label: data.area_name })
          return acc
        }, [])
        setLocationAll(optionData)
      }

      setPoData(res.data.data)
      const initialBranch = res.data.data.branch || ''
      setSelectedBranch(initialBranch)
      if (initialBranch) {
        getWarehouses(initialBranch)
      }
    } catch (err) {
      const errMsg = err?.response?.data?.errors?.message || 'An error occurred'
      Common.showPopUpErrorMessage(errMsg)
    } finally {
      setIsLoadingPage(false)
    }
  }

  const loadItems = async () => {
    try {
      const res = await api.get(`/inbound/pr-draft/show-items?po=${code}`)
      const { data } = res.data
      setItems(data)
    } catch (err) {
      const errMsg = err?.response?.data?.errors?.message || 'An error occurred'
      Common.showPopUpErrorMessage(errMsg)
    }
  }

  const handleSubmit = (values) => {
    const title =
      method === 'cross_dock' || typeWarehouseExternal ? '' : 'Are you sure?'
    let text = 'This will also create new inbound document. Proceed ?'
    let confirmButtonText = 'Yes, add it!'
    if (method === 'cross_dock') {
      text = 'Create Cross Doc PR Draft?'
      confirmButtonText = 'Create'
    }
    if (method !== 'cross_dock' && typeWarehouseExternal) {
      text = 'Create PR Draft?'
      confirmButtonText = 'Create'
    }
    Swal.fire({
      title,
      text,
      icon: 'warning',
      iconColor: '#828282',
      showCancelButton: true,
      confirmButtonColor: '#f89d1d',
      confirmButtonText,
      customClass: {
        title: 'swal-title-outbound',
        popup: 'swal-popup-outbound',
        actions: 'swal-cancel-pr'
      }
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          setIsLoading(true)
          if (pr_type === 'import') {
            values.pib_date = convertDateWithTime(values.pib_date, 'YYYY-MM-DD')
          }
          const mappedVehicles = vehicles.map((v) => ({
            ...v,
            sim_doc: undefined,
            stnk_doc: undefined,
            sim_doc_temp_path: v.sim_doc_temp_path || null,
            stnk_doc_temp_path: v.stnk_doc_temp_path || null
          }))

          const mappedItemCoas = typeWarehouseExternal
            ? itemCoas?.map((cur) => ({
                ...cur,
                receiving_uom: cur.conversion_uom,
                area_id: cur.area_id?.value || cur.area_id,
                coa: undefined,
                coa_temp_path: cur.document_id
                  ? null
                  : cur.coa_temp_path || null
              }))
            : itemCoas.map((item_coa) => ({
                ...item_coa,
                receiving_uom: item_coa.conversion_uom,
                coa: undefined,
                coa_temp_path: item_coa.document_id
                  ? null
                  : item_coa.coa_temp_path || null
              }))

          const attachmentPaths = attachments.map((att) => ({
            temp_path: att.temp_path
          }))

          let data = null
          if (!typeWarehouseExternal) {
            if (method !== 'cross_dock') {
              data = {
                ...values,
                receiving_uom: undefined,
                vehicles: mappedVehicles,
                item_coas: mappedItemCoas,
                po_num: poData.po_name
              }
            } else {
              data = {
                ...values,
                receiving_uom: undefined,
                item_coas: mappedItemCoas,
                po_num: poData.po_name,
                attachments: attachmentPaths
              }
            }
          } else {
            data = {
              ...values,
              receiving_uom: undefined,
              vehicles: mappedVehicles,
              item_coas: mappedItemCoas,
              po_num: poData.po_name,
              attachments: attachmentPaths
            }
          }
          data.accepted_warehouse = selectedWarehouse
          data.pr_method = method
          data.branch = selectedBranch
          const res = await api.post(`/inbound/pr-draft`, data)
          if (res.data.success) {
            navigate('/inbound/purchase-receipt')
            Common.showPopUpSuccessMessage(res.data.message)
            setIsLoading(false)
          }
        } catch (error) {
          const errMsg =
            error?.response?.data?.errors?.message ||
            error?.message ||
            'An error occurred'
          Common.showPopUpErrorMessage(errMsg)
          setIsLoading(false)
        }
      }
    })
  }

  const handleChangeUploadAttachment = async (e) => {
    const file = e.target.files[0]
    if (!file) {
      const errMsg = 'File attachment is required'
      Common.showPopUpErrorMessage(errMsg)
      return
    }

    if (file.type !== 'application/pdf') {
      const errMsg = 'File attachment must be file PDF'
      Common.showPopUpErrorMessage(errMsg)
      return
    }

    if (file.size > FILE_SIZE) {
      const errMsg = 'File attachment must be less than 5MB'
      Common.showPopUpErrorMessage(errMsg)
      return
    }

    setUploadingAttachment(true)
    try {
      const { tempPath, fileName } = await uploadFileViaPresignedUrl(file)
      setAttachments((prevAttachments) => [
        ...prevAttachments,
        { name: fileName, temp_path: tempPath }
      ])
    } catch (err) {
      Common.showPopUpErrorMessage('Failed to upload attachment')
    } finally {
      setUploadingAttachment(false)
    }
  }

  const handleRemoveUploadAttachment = (index) => {
    setAttachments((prevAttachments) =>
      prevAttachments.filter((_, i) => i !== index)
    )
  }

  const handleDragOver = (event) => {
    event.preventDefault()
    setIsDragging(true)
  }

  const handleDragLeave = (event) => {
    event.preventDefault()
    setIsDragging(false)
  }

  const handleDrop = async (event) => {
    event.preventDefault()
    const file = event.dataTransfer.files[0]
    if (!file) {
      const errMsg = 'File attachment is required'
      Common.showPopUpErrorMessage(errMsg)
      setIsDragging(false)
      return
    }
    if (file.type !== 'application/pdf') {
      const errMsg = 'File attachment must be file PDF'
      Common.showPopUpErrorMessage(errMsg)
      setIsDragging(false)
      return
    }
    if (file.size > FILE_SIZE) {
      const errMsg = 'File attachment must be less than 5MB'
      Common.showPopUpErrorMessage(errMsg)
      return
    }

    setUploadingAttachment(true)
    try {
      const { tempPath, fileName } = await uploadFileViaPresignedUrl(file)
      setAttachments((prevAttachments) => [
        ...prevAttachments,
        { name: fileName, temp_path: tempPath }
      ])
    } catch (err) {
      Common.showPopUpErrorMessage('Failed to upload attachment')
    } finally {
      setUploadingAttachment(false)
      setIsDragging(false)
    }
    event.dataTransfer.clearData()
  }

  const addVehicle = (values) => {
    const isPlateNoExists = vehicles.some(
      (vehicle) => vehicle.plate_no === values
    )

    if (isPlateNoExists) {
      Common.showPopUpErrorMessage('Plate No already in list')
      return
    }

    const newVehicle = {
      id: vehicles.length + 1,
      plate_no: values,
      sim: '',
      sim_validity: null,
      sim_notes: '',
      stnk: '',
      stnk_validity: null,
      stnk_notes: '',
      sim_doc: '',
      stnk_doc: ''
    }

    setVehicles([...vehicles, newVehicle])
  }

  useEffect(() => {
    if (vehicles.length > 0) {
      const simDocs = vehicles.map((vehicle) => vehicle.sim_doc)
      const stnkDocs = vehicles.map((vehicle) => vehicle.stnk_doc)
      const hasNullSimDoc = simDocs.some((simDoc) => simDoc === '')
      const hasNullStnkDoc = stnkDocs.some((stnkDoc) => stnkDoc === '')
      setSimDocFile(!hasNullSimDoc)
      setStnkDocFile(!hasNullStnkDoc)
    }

    if (itemCoas.length > 0) {
      const hasNullCoaDoc = itemCoas.some(
        (itemCoa) =>
          itemCoa.coa === '' && !itemCoa.document_id && !itemCoa.coa_temp_path
      )
      setCoaDocFile(!hasNullCoaDoc)
    }
  }, [vehicles, itemCoas])

  const addItemCoas = (
    totalPack,
    totalQty,
    conversionUom,
    conversionQtyUom,
    conversionFactor
  ) => {
    // check batch exist or not
    const batchExist = itemCoas.some(
      (itemCoa) => itemCoa.batch.id === inputBatch.id
    )
    if (!batchExist) {
      const maxId =
        itemCoas.length > 0 ? Math.max(...itemCoas.map((item) => item.id)) : 0
      setItemCoas([
        ...itemCoas,
        {
          id: maxId + 1,
          item_id: itemId,
          total_pack: Number(totalPack),
          total_qty: Number(totalQty),
          conversion_factor: conversionFactor,
          conversion_uom: conversionUom,
          conversion_qty_uom: conversionQtyUom,
          receiving_uom: conversionUom,
          items: dataItemSelect,
          batch: inputBatch,
          batch_id: batchId,
          document_id: inputBatch?.document_id,
          document_name: inputBatch?.document_name,
          coa: '',
          havingCoa: inputBatch?.document_id ? true : false,
          coa_pd: inputBatch?.newBatch
            ? inputBatch?.manufacturing_date
            : batchSelectedDetail?.manufacturing_date,
          coa_ed: inputBatch?.newBatch
            ? inputBatch?.exp_date
            : batchSelectedDetail?.exp_date,
          label_pd:
            (method === 'cross_dock' ||
              dataWarehouses?.find(
                (dataWarehouse) => dataWarehouse.id === selectedWarehouse
              )?.is_external_warehouse) &&
            inputBatch?.newBatch
              ? convertDateWithTime(
                  inputBatch?.manufacturing_date,
                  'YYYY-MM-DD'
                )
              : method === 'cross_dock' ||
                  dataWarehouses?.find(
                    (dataWarehouse) => dataWarehouse.id === selectedWarehouse
                  )?.is_external_warehouse
                ? batchSelectedDetail?.manufacturing_date
                : '',
          label_ed:
            (method === 'cross_dock' ||
              dataWarehouses?.find(
                (dataWarehouse) => dataWarehouse.id === selectedWarehouse
              )?.is_external_warehouse) &&
            inputBatch?.newBatch
              ? convertDateWithTime(inputBatch?.exp_date, 'YYYY-MM-DD')
              : method === 'cross_dock' ||
                  dataWarehouses?.find(
                    (dataWarehouse) => dataWarehouse.id === selectedWarehouse
                  )?.is_external_warehouse
                ? batchSelectedDetail?.exp_date
                : '',
          area_id: null,
          remark: '',
          problem: null
        }
      ])
      setBatchSelectedDetail(null)
    } else {
      Common.showPopUpErrorMessage('Batch already in list')
    }
  }

  function handleUpdateVehicle(item) {
    setModalUpdateShow(true)
    setSelectedVehicle(item)
  }

  function handleUpdateItemCoa(item) {
    setModalUpdateItemShow(true)
    setSelectedItemCoa(item)
  }

  function handleAddBatch(item) {
    setModalAddBatch(true)
  }

  function handleAddCategory(item) {
    setModalAddCategory(true)
    setListItemsId(item)
  }

  const updateVehicleInList = (updatedVehicle) => {
    const updatedVehicles = vehicles.map((vehicle) =>
      vehicle.id === updatedVehicle.id ? updatedVehicle : vehicle
    )
    setVehicles(updatedVehicles)
  }

  const updateItemCoasInList = (updatedItemCoas) => {
    const updatedItemCoass = itemCoas.map((itemCoa) =>
      itemCoa.id === updatedItemCoas.id ? updatedItemCoas : itemCoa
    )
    setItemCoas(updatedItemCoass)
  }

  async function handleClickItem(item) {
    setSelectItem(item)
    let selectedItem = null
    items.forEach((b) => {
      if (b.id === item.id) {
        setDataItemSelect(b)
        selectedItem = b
      }
    })
    setItemId(item.id)
    if (item.id !== '0' && item.id !== 0) {
      try {
        const res = await api.get(`/master/items/${item.id}/uoms`)
        const uomData = res.data.data
        setUomOptions(
          uomData.map((u) => ({ id: u.uom_name, name: u.uom_name, ...u }))
        )
        const defaultUom = uomData.find((u) => u.is_pack) || uomData[0]
        setSelectedUom(defaultUom)
        setTotalPack((prevData) => {
          const uomObj =
            typeof selectedItem?.uom === 'object' ? selectedItem?.uom : null
          return {
            ...prevData,
            total_qty: 0,
            conversion_uom: defaultUom?.uom_name || '',
            conversion_qty_uom: uomObj
              ? uomObj.conversion_uom
              : selectedItem?.uom || '',
            conversion_factor: uomObj
              ? uomObj.conversion_factor
              : defaultUom?.convertion_factor || 0
          }
        })
      } catch (err) {
        const errMsg =
          err?.response?.data?.errors?.message || 'An error occurred'
        Common.showPopUpErrorMessage(errMsg)
      }
    }
  }

  function onDeleteItemCoa(item) {
    Swal.fire({
      title: 'Are you sure delete?',
      text: "You won't be able to revert this!",
      icon: 'warning',
      allowOutsideClick: false,
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Yes, delete it!'
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          const index = itemCoas.findIndex((coa) => coa.id === item.id)
          if (index !== -1) {
            const updatedItemCoas = [...itemCoas]
            updatedItemCoas.splice(index, 1)
            setItemCoas(updatedItemCoas)
          }
        } catch (err) {
          const errMsg = err?.message || 'An error occurred'
          Common.showPopUpErrorMessage(errMsg)
        }
      }
    })
  }

  function onDeleteItemVehicle(item) {
    Swal.fire({
      title: 'Are you sure delete?',
      text: "You won't be able to revert this!",
      icon: 'warning',
      allowOutsideClick: false,
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Yes, delete it!'
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          const index = vehicles.findIndex((vehicle) => vehicle.id === item.id)
          if (index !== -1) {
            const updatedVehicle = [...vehicles]
            updatedVehicle.splice(index, 1)
            setVehicles(updatedVehicle)
          }
        } catch (err) {
          const errMsg = err?.message || 'An error occurred'
          Common.showPopUpErrorMessage(errMsg)
        }
      }
    })
  }

  const handleSearch = useDebouncedCallback(async (query) => {
    const params = {
      item_id: itemId,
      q: query
    }
    const res = await api.get('inbound/pr-draft/show-batches', { params })
    setOptions(res.data.data)
    setNewOption({ batch: query })
  }, 1000)

  const getWarehouses = async (branch) => {
    try {
      const params = {
        branch
      }
      const res = await api.get('/inbound/pr-draft/accepted-warehouses', {
        params
      })
      if (res.status === 200) {
        let options = res.data.data
        if (method === 'cross_dock') {
          options = res.data.data.filter((data) => !data.is_external_warehouse)
        }
        const optionData = options.reduce((acc, data) => {
          acc.push({ value: data.id, label: data.warehouse_id })
          return acc
        }, [])
        setWarehouses(optionData)
        setDataWarehouses(res.data.data)
      }
    } catch (err) {
      const errMsg = err?.response?.data?.errors?.message || 'An error occurred'
      Common.showPopUpErrorMessage(errMsg)
    }
  }

  const renderMenuItemChildren = (option) => (
    <div>
      {option.isNew ? (
        <>
          <h6 onClick={() => handleAddBatch(option)}>
            <Plus size={16} className="me-1" /> NEW BATCH
          </h6>
        </>
      ) : (
        <span>{option.batch}</span>
      )}
    </div>
  )

  const allOptions = [
    ...options,
    ...(newOption ? [{ ...newOption, isNew: true }] : [])
  ]

  const refBatch = useRef(AsyncTypeahead)
  const refItems = useRef(null)

  const fetchSeries = async () => {
    try {
      const res = await api.get(`inbound/pr-draft/show-series?po=${code}`)
      const { data } = res.data
      const series = data.map((item) => ({
        ...item,
        label: item.name,
        value: item.name
      }))
      setSeries(series)
    } catch (err) {
      const errMsg = err?.response?.data?.errors?.message || 'An error occurred'
      Common.showPopUpErrorMessage(errMsg)
    }
  }

  const removeWhiteSpace = (value) => {
    return value.trim()
  }

  const customStyles = {
    control: (base) => ({
      ...base,
      height: '40px',
      minHeight: '40px',
      borderRadius: '8px',
      fontSize: '0.9rem',
      backgroundColor: '#fff',
      border: '1px solid #ced4da',
      boxShadow: 'none'
    }),
    valueContainer: (provided, state) => ({
      ...provided,
      height: '40px',
      padding: '0 16px'
    }),
    input: (provided, state) => ({
      ...provided,
      margin: '0px'
    }),
    indicatorSeparator: () => ({
      display: 'none'
    })
  }

  const loadOptions = useCallback(
    async (inputValue = '') => {
      try {
        setLoadingArea(true)
        const res = await api.get('/master/area/all', {
          params: {
            q: inputValue,
            id:
              dataWarehouses.find(
                (dataWarehouse) => dataWarehouse.id === selectedWarehouse
              )?.warehouse_id || ''
          }
        })

        if (res.data.success) {
          const dataCoa =
            itemCoas?.find((itemCoa) => itemCoa.id === itemCoaIdValue) || ''
          const coaMatch = dataCoa
            ? dataCoa.coa_pd === dataCoa.label_pd &&
              dataCoa.coa_ed === dataCoa.label_ed
            : true

          const filteredData = res.data.data
            .filter((data) => (coaMatch ? data : data.code !== 'UT')) // Only exclude 'UT' if not matching
            .map((cur) => ({
              value: cur.id,
              label: cur.name,
              code: cur.code
            }))

          return filteredData
        }
      } catch (err) {
        const errMsg =
          err?.response?.data?.errors?.message || 'An error occurred'
        Common.showPopUpErrorMessage(errMsg)
        console.error('Error loading options:', err)
      } finally {
        setLoadingArea(false)
      }
    },
    [dataWarehouses, itemCoaIdValue, selectedWarehouse, itemCoas]
  )

  const handleChangeItemCoa = (type, itemCoaId, value) => {
    setItemCoas((prevItemCoas) =>
      prevItemCoas.map((itemCoasMap) => {
        if (itemCoasMap.id === itemCoaId) {
          if (type === 'area_id') {
            const warehouseCode =
              dataWarehouses.find(
                (dataWarehouse) => dataWarehouse.value === value.value
              )?.code || null
            return {
              ...itemCoasMap,
              [type]: value,
              problem: warehouseCode === 'UT' ? '' : itemCoasMap.problem,
              remark: warehouseCode === 'UT' ? '' : itemCoasMap.remark
            }
          }
          return {
            ...itemCoasMap,
            [type]: value
          }
        }
        return itemCoasMap
      })
    )
  }

  const handleDownloadDocumentCoa = async (batch_id, document_id) => {
    try {
      const res = await api.get(`/master/batch/${batch_id}/download-coa`, {
        responseType: 'arraybuffer'
      })
      const { status, data } = res
      if (status === 200) {
        const blob = new Blob([data], { type: 'application/pdf' })
        const url = window.URL.createObjectURL(blob)

        const link = document.createElement('a')
        link.href = url
        link.setAttribute('download', `download-co  a-${batch_id}.pdf`)
        document.body.appendChild(link)
        link.click()

        document.body.removeChild(link)
        window.URL.revokeObjectURL(url)
      }
    } catch (error) {
      const err = error?.response?.data?.errors?.message || 'An error occurred'
      Common.showPopUpErrorMessage(err)
    }
  }

  const variantButtonSubmit = useCallback(
    (dirty, valid) => {
      if (method === 'cross_dock') {
        if (!dirty) {
          return 'secondary'
        }
        if (
          !valid ||
          !itemCoas.length ||
          itemCoas.some(
            (itemCoa) =>
              itemCoa.coa === '' &&
              !itemCoa.document_id &&
              !itemCoa.coa_temp_path
          ) ||
          attachments.length === 0
        ) {
          return 'secondary'
        }
      } else {
        if (!dirty) {
          return 'secondary'
        }
        if (
          (!simDocFile && !stnkDocFile) ||
          !valid ||
          !itemCoas.length ||
          (itemCoas.length > 0 &&
            itemCoas.filter(
              (itemCoa) =>
                itemCoa.coa === '' &&
                !itemCoa?.document_id &&
                !itemCoa?.coa_temp_path
            ).length > 0)
        ) {
          return 'secondary'
        }
        if (
          typeWarehouseExternal &&
          (attachments.length === 0 ||
            !itemCoas.length ||
            itemCoas.filter(
              (itemCoa) =>
                !itemCoa.area_id ||
                itemCoa.coa_pd === '' ||
                itemCoa.coa_ed === '' ||
                itemCoa.label_pd === '' ||
                itemCoa.label_ed === '' ||
                (itemCoa.area_id.code !== 'UT' && itemCoa.remark === '')
            )?.length > 0)
        ) {
          return 'secondary'
        }
      }

      return 'warning'
    },
    [
      method,
      itemCoas,
      simDocFile,
      stnkDocFile,
      coaDocFile,
      typeWarehouseExternal,
      attachments
    ]
  )

  const disableButtonAddItemCoa = useMemo(() => {
    if (itemId) {
      // check itemId exist in data items
      const itemExist = items?.find((item) => item.id === itemId)
      if (!itemExist) {
        return true
      }
      // check itemId exits in data itemCoas
      const itemCoaExist =
        itemCoas?.filter((itemCoa) => itemCoa.item_id === itemId) || []
      const totalQtyRemaining =
        Number(itemExist?.remaining_qty || 0) -
        Number(
          itemCoaExist?.reduce(
            (total, itemCoa) => total + itemCoa.total_qty,
            0
          ) || 0
        )
      if (Number(totalPack?.total_qty) > Number(totalQtyRemaining)) {
        return true
      }
      return false
    }
    return !itemId ? true : false
  }, [itemId, totalPack, itemCoas, items, selectedUom])

  useEffect(() => {
    loadData()
    loadItems()
    fetchSeries()
  }, [])

  useEffect(() => {
    if (itemCoaIdValue) {
      loadOptions()
        .then((options) => setAreaOptions(options))
        .catch((err) => console.error('Error in loadOptions:', err))
    }
  }, [itemCoaIdValue, loadOptions])

  if (isLoadingPage) {
    return <Loading />
  }

  return (
    <>
      <Container fluid className="px-4 mb-5">
        <Row className="mb-2 mt-3">
          <Col>
            <BreadCrumb
              label={'Create PR Draft'}
              link="/purchase-order"
              back="Purchase Order"
            />
          </Col>
        </Row>
        <Formik
          initialValues={{
            do: '',
            pib_date: '',
            expedition: '',
            aju: '',
            pic_number: '',
            pr_type: pr_type ? pr_type : poData.type,
            vehicle: '',
            total_pack: '',
            series_number: ''
          }}
          enableReinitialize={true}
          validateOnChange={true}
          validationSchema={
            pr_type === 'import'
              ? PurchaseReceiptCreateImportSchema
              : PurchaseReceiptCreateLocalSchema
          }
          onSubmit={(values) => {
            handleSubmit(values)
          }}
          context={{ pr_type }}
        >
          {({
            handleSubmit,
            handleChange,
            handleBlur,
            values,
            touched,
            errors,
            isValid,
            dirty,
            setFieldValue,
            setFieldTouched
          }) => {
            return (
              <Form onSubmit={handleSubmit}>
                <Card style={cardStyle}>
                  <Row className="gy-4">
                    <StyledTextField
                      label="#po"
                      name="po_name"
                      value={poData.po_name}
                      touched={touched}
                      errors={errors}
                      disabled={true}
                      col={4}
                    />
                    <StyledTextField
                      label="po type"
                      name="po_type"
                      value={pr_type ? pr_type : poData.type}
                      touched={touched}
                      errors={errors}
                      disabled={true}
                      col={4}
                    />
                    <StyledSelectInput
                      label="branch"
                      name="po_branch"
                      value={selectedBranch}
                      handleChange={(e) => {
                        const newBranch = e.target.value
                        setSelectedBranch(newBranch)
                        setSelectedWarehouse('')
                        setWarehouses([])
                        if (newBranch) {
                          getWarehouses(newBranch)
                        }
                      }}
                      options={locationAll}
                      required={true}
                      col={4}
                    />
                    <StyledTextField
                      label="supplier"
                      name="po_supplier"
                      value={poData.supplier}
                      touched={touched}
                      errors={errors}
                      disabled={true}
                      col={4}
                    />
                    <div className="col-12 col-md-4">
                      <Form.Label style={labelDetailStyle}>
                        Series Number
                      </Form.Label>
                      <Select
                        isClearable
                        defaultValue={values.series_number || ''}
                        styles={customStyles}
                        onChange={(e) => {
                          setFieldValue('series_number', e?.value)
                          setFieldTouched('series_number', true, false)
                        }}
                        options={series}
                        isSearchable
                        ref={refSeriesNumber}
                      />
                      {errors?.series_number && touched?.series_number && (
                        <div className="text-danger">
                          {errors.series_number}
                        </div>
                      )}
                    </div>
                    <div className="col-12 col-md-4">
                      <Form.Label style={labelDetailStyle}>
                        Accepted Warehouse
                      </Form.Label>
                      <Select
                        isClearable
                        value={
                          warehouses.find(
                            (w) => w.value === selectedWarehouse
                          ) || null
                        }
                        styles={customStyles}
                        onChange={(e) => {
                          if (!e) {
                            e = {
                              target: refSrcWarehouses,
                              value: ''
                            }
                          }
                          const isExternalWarehouse = dataWarehouses?.find(
                            (item) => item.id === e?.value
                          )?.is_external_warehouse
                          setSelectedWarehouse(e?.value)
                          setTypeWarehouseExternal(isExternalWarehouse ?? false)
                        }}
                        options={warehouses}
                        isSearchable
                        ref={refSrcWarehouses}
                      />
                    </div>
                    <StyledTextField
                      label="method"
                      name="method"
                      value={transformKey(method)}
                      touched={touched}
                      errors={errors}
                      disabled={true}
                      col={4}
                    />
                  </Row>
                </Card>

                <Card style={cardStyle}>
                  <Card.Header className="bg-white border-0 pt-3 pb-0 ps-0">
                    <h5 className="text-secondary fw-bold">ARRIVAL INFO</h5>
                  </Card.Header>
                  <Card.Body className="px-0">
                    <Row className="gy-4">
                      <StyledTextField
                        label="#do"
                        name="do"
                        value={values.do}
                        handleChange={(e) => {
                          const capitalizedValue = capitalizeWords(
                            e.target.value
                          )
                          setFieldValue('do', capitalizedValue)
                        }}
                        handleBlur={handleBlur}
                        touched={touched}
                        errors={errors}
                        placeholder="Input do"
                        col={4}
                        required
                      />
                      <StyledTextField
                        label="expedition"
                        name="expedition"
                        value={values.expedition}
                        handleChange={(e) => {
                          const capitalizedValue = capitalizeWords(
                            e.target.value
                          )
                          setFieldValue('expedition', capitalizedValue)
                        }}
                        handleBlur={handleBlur}
                        touched={touched}
                        errors={errors}
                        placeholder="Input expedition"
                        col={4}
                        required
                      />
                      {pr_type === 'import' && (
                        <>
                          <DatePickerComponent
                            label="pib date"
                            name="pib_date"
                            value={values.pib_date}
                            handleChange={setFieldValue}
                            handleBlur={() => setFieldTouched('pib_date', true)}
                            errors={errors}
                            touched={touched}
                            col={4}
                            required
                          />
                          <StyledTextField
                            label="#aju"
                            name="aju"
                            value={values.aju}
                            handleChange={(e) => {
                              const capitalizedValue = capitalizeWords(
                                e.target.value
                              )
                              setFieldValue('aju', capitalizedValue)
                            }}
                            handleBlur={handleBlur}
                            touched={touched}
                            errors={errors}
                            col={4}
                            required
                            placeholder="Input aju"
                          />
                        </>
                      )}
                      <StyledTextField
                        label="pic name"
                        name="pic_name"
                        value={values.pic_name}
                        handleChange={(e) => {
                          const capitalizedValue = capitalizeWords(
                            e.target.value
                          )
                          setFieldValue('pic_name', capitalizedValue)
                        }}
                        handleBlur={handleBlur}
                        touched={touched}
                        errors={errors}
                        col={4}
                        required
                        placeholder="Input pic name"
                      />
                      <StyledTextField
                        label="pic number"
                        name="pic_number"
                        value={values.pic_number}
                        handleChange={handleChange}
                        handleBlur={handleBlur}
                        touched={touched}
                        errors={errors}
                        type="number"
                        col={4}
                        required
                        placeholder="Input pic number"
                      />
                    </Row>
                  </Card.Body>
                </Card>
                {/* VEHICLE */}
                {method !== 'cross_dock' && (
                  <Card style={cardStyle}>
                    <Card.Header className="bg-white border-0 pt-3 pb-0 ps-0">
                      <h5 className="text-secondary fw-bold">VEHICLE</h5>
                    </Card.Header>
                    <Card.Body className="px-0">
                      <Row>
                        <Col md={10}>
                          <StyledTextField
                            label="plate no."
                            name="vehicle"
                            value={values.vehicle}
                            handleChange={(e) => {
                              const capitalizedValue = capitalizeWords(
                                e.target.value
                              )
                              const removeWhiteSpaceValue =
                                removeWhiteSpace(capitalizedValue)
                              setFieldValue('vehicle', removeWhiteSpaceValue)
                            }}
                            handleBlur={handleBlur}
                            touched={touched}
                            errors={errors}
                            required
                            placeholder="Input vehicle"
                            col={12}
                          />
                        </Col>
                        <Col
                          md={2}
                          className="text-end d-flex align-items-end mb-3"
                        >
                          <Button
                            type="button"
                            className="btn btn-primary-blue w-100"
                            style={{ height: '40px' }}
                            onClick={() => {
                              addVehicle(values.vehicle)
                              setFieldValue('vehicle', '')
                            }}
                            disabled={!values.vehicle}
                          >
                            Add Vehicle
                          </Button>
                        </Col>
                        <Col md={12} className="mt-3">
                          {vehicles.length > 0 && (
                            <Table
                              hover
                              responsive
                              className="shadow-sm mb-5 bg-white rounded"
                              size="sm"
                              style={{ fontSize: '12px' }}
                            >
                              <thead style={{ backgroundColor: '#f8f9fa' }}>
                                <tr>
                                  <th
                                    className="p-2 align-middle"
                                    style={tableHeaderStyle}
                                  >
                                    No
                                  </th>
                                  <th
                                    className="p-2"
                                    style={{
                                      ...tableHeaderStyle,
                                      width: '30%'
                                    }}
                                  >
                                    Plate No
                                  </th>
                                  <th
                                    className="p-2 text-end align-middle"
                                    style={tableHeaderStyle}
                                  >
                                    SIM
                                  </th>
                                  <th
                                    className="p-2 text-end align-middle"
                                    style={tableHeaderStyle}
                                  >
                                    Validity
                                  </th>
                                  <th
                                    className="p-2 text-end align-middle"
                                    style={tableHeaderStyle}
                                  >
                                    Notes
                                  </th>
                                  <th
                                    className="p-2 text-end align-middle"
                                    style={tableHeaderStyle}
                                  >
                                    STNK
                                  </th>
                                  <th
                                    className="p-2 text-end align-middle"
                                    style={tableHeaderStyle}
                                  >
                                    Validity
                                  </th>
                                  <th
                                    className="p-2 text-end align-middle"
                                    style={tableHeaderStyle}
                                  >
                                    Notes
                                  </th>
                                  <th
                                    className="p-2 text-end align-middle"
                                    style={tableHeaderStyle}
                                  >
                                    Action
                                  </th>
                                </tr>
                              </thead>
                              <tbody>
                                {vehicles.map((vehicle, index) => (
                                  <tr key={index}>
                                    <td className="p-2 align-middle">
                                      {index + 1}
                                    </td>
                                    <td className="p-2 align-middle">
                                      {vehicle.plate_no
                                        ? vehicle.plate_no.toUpperCase()
                                        : '-'}
                                    </td>
                                    <td className="p-2 text-end align-middle text-primary">
                                      {vehicle.sim_doc.name || '-'}
                                    </td>
                                    <td className="p-2 text-end align-middle">
                                      {vehicle.sim_validity === null
                                        ? '-'
                                        : vehicle.sim_validity === true
                                          ? 'Valid'
                                          : 'Invalid'}
                                    </td>
                                    <td
                                      className="p-2 text-end align-middle"
                                      style={{
                                        wordBreak: 'break-word',
                                        whiteSpace: 'normal',
                                        minWidth: '100px',
                                        maxWidth: '150px'
                                      }}
                                    >
                                      {vehicle.sim_notes || '-'}
                                    </td>
                                    <td className="p-2 text-end align-middle text-primary">
                                      {vehicle.stnk_doc.name || '-'}
                                    </td>
                                    <td className="p-2 text-end align-middle">
                                      {vehicle.stnk_validity === null
                                        ? '-'
                                        : vehicle.stnk_validity === true
                                          ? 'Valid'
                                          : 'Invalid'}
                                    </td>
                                    <td
                                      className="p-2 text-end align-middle"
                                      style={{
                                        wordBreak: 'break-word',
                                        whiteSpace: 'normal',
                                        minWidth: '100px',
                                        maxWidth: '150px'
                                      }}
                                    >
                                      {vehicle.stnk_notes || '-'}
                                    </td>
                                    <td className="p-2 text-end align-middle">
                                      <div className="d-flex flex-row gap-2 justify-content-end">
                                        <div className="d-flex flex-column justify-content-center">
                                          <CircleAlert
                                            size={16}
                                            className="text-danger me-2"
                                            hidden={
                                              vehicle.sim_doc !== '' &&
                                              vehicle.stnk_doc !== ''
                                                ? true
                                                : false
                                            }
                                          />
                                        </div>
                                        <button
                                          className="btn btn-secondary ml-2"
                                          type="button"
                                          onClick={() =>
                                            handleUpdateVehicle(vehicle)
                                          }
                                        >
                                          <SquarePen size={14} />
                                        </button>
                                        <button
                                          type="button"
                                          className="btn btn-danger ml-2"
                                          onClick={() =>
                                            onDeleteItemVehicle(vehicle)
                                          }
                                        >
                                          <Trash2 size={14} />
                                        </button>
                                      </div>
                                    </td>
                                  </tr>
                                ))}
                              </tbody>
                            </Table>
                          )}
                        </Col>
                      </Row>
                    </Card.Body>
                  </Card>
                )}
                {/* ITEM & COA */}
                <Card style={cardStyle}>
                  <Card.Header className="bg-white border-0 pt-3 pb-0 ps-0">
                    <h5 className="text-secondary fw-bold">ITEM & COA</h5>
                  </Card.Header>
                  <Card.Body className="px-0">
                    <Row className="mb-1">
                      <StyledSelectInput
                        label="item"
                        name="item_id"
                        id="item_id"
                        handleChange={(e) => {
                          const selectedOption =
                            e.target.options[e.target.selectedIndex]
                          const selectedHasCategory = parseInt(
                            selectedOption.getAttribute('hasData')
                          )
                          return handleClickItem({
                            id: e.target.value,
                            name: e.target.options[e.target.selectedIndex].text,
                            has_category: selectedHasCategory
                          })
                        }}
                        reff={refItems}
                        handleBlur={handleBlur}
                        touched={touched}
                        errors={errors}
                        options={items}
                        required
                        hasData
                        col={4}
                      />
                      <Form.Group className="col-12 col-md-2 col-lg-2">
                        <Form.Label style={labelDetailStyle}>
                          BATCH NUMBER <sup className="text-danger">*</sup>
                        </Form.Label>
                        <AsyncTypeahead
                          id="async-typeahead-example"
                          labelKey="batch"
                          onSearch={handleSearch}
                          options={allOptions}
                          renderMenuItemChildren={renderMenuItemChildren}
                          onChange={(e) => {
                            setInputBatch(e.length > 0 ? e[0] : '')
                            setBatchId(e.length > 0 ? e[0].id : 0)
                            setBatchSelectedDetail(e.length > 0 ? e[0] : null)
                          }}
                          inputProps={{
                            value: inputBatch,
                            className: 'border-0 bg-light px-3 form-control',
                            style: {
                              fontSize: '0.9rem',
                              height: '40px',
                              borderRadius: '8px'
                            }
                          }}
                          placeholder="Input"
                          disabled={
                            itemId === '0' || itemId === 0 ? true : false
                          }
                          ref={refBatch}
                        />
                      </Form.Group>
                      <StyledTextField
                        label="receiving pack"
                        name="total_pack"
                        type="number"
                        value={values.total_pack}
                        handleChange={(e) => {
                          handleChange(e)
                          setTotalPack((prevData) => {
                            const uomObj =
                              typeof dataItemSelect?.uom === 'object'
                                ? dataItemSelect?.uom
                                : null
                            return {
                              ...prevData,
                              total_qty:
                                e.target.value *
                                (selectedUom?.convertion_factor || 0),
                              conversion_uom: selectedUom?.uom_name || '',
                              conversion_qty_uom: uomObj
                                ? uomObj.conversion_uom
                                : dataItemSelect?.uom || '',
                              conversion_factor:
                                selectedUom?.convertion_factor || 0
                            }
                          })
                        }}
                        handleBlur={handleBlur}
                        touched={touched}
                        errors={errors}
                        col={2}
                        required
                        placeholder="Input"
                        disabled={itemId === '0' || itemId === 0 ? true : false}
                      />

                      <StyledSelectInput
                        label="receiving uom"
                        name="receiving_uom"
                        value={selectedUom?.uom_name || ''}
                        handleChange={(e) => {
                          handleChange(e)
                          const uom = uomOptions.find(
                            (u) => u.uom_name === e.target.value
                          )
                          setSelectedUom(uom)
                          setTotalPack((prevData) => ({
                            ...prevData,
                            total_qty:
                              values.total_pack * (uom?.convertion_factor || 0),
                            conversion_uom: uom?.uom_name || '',
                            conversion_factor: uom?.convertion_factor || 0
                          }))
                        }}
                        handleBlur={handleBlur}
                        touched={touched}
                        errors={errors}
                        options={uomOptions}
                        col={2}
                        required
                        disabled={itemId === '0' || itemId === 0 ? true : false}
                      />

                      <StyledTextField
                        label="base uom qty"
                        name="total_qty"
                        value={totalPack.total_qty}
                        touched={touched}
                        errors={errors}
                        col={2}
                        required
                        disabled
                      />
                      <Col
                        md={2}
                        className="text-end d-flex align-items-end mb-3"
                      >
                        <Button
                          className="btn btn-primary-blue w-100"
                          style={{ height: '40px' }}
                          onClick={() => {
                            addItemCoas(
                              values.total_pack,
                              totalPack.total_qty,
                              totalPack.conversion_uom,
                              totalPack.conversion_qty_uom,
                              totalPack.conversion_factor
                            )
                            setFieldValue('total_pack', '')
                            refBatch.current?.clear()
                            refItems.current.value = ''
                            setTotalPack({
                              total_qty: 0,
                              conversion_uom: '',
                              conversion_qty_uom: '',
                              conversion_factor: ''
                            })
                            setItemId(0)
                            setDataItemSelect(null)
                            setSelectedUom(null)
                            setBatchId(0)
                            setInputBatch('')
                          }}
                          disabled={
                            !values.total_pack || disableButtonAddItemCoa
                          }
                        >
                          Add Item
                        </Button>
                      </Col>
                      <Col md={12} className="mt-3">
                        {itemCoas.length > 0 && (
                          <Table
                            hover
                            responsive
                            className="shadow-sm mb-5 bg-white rounded"
                            size="sm"
                            style={{ fontSize: '12px' }}
                          >
                            <thead className="table-secondary">
                              <tr>
                                <th className="p-2 align-middle">No</th>
                                <th
                                  className="p-2 align-middle"
                                  style={{ width: '20%' }}
                                >
                                  Item
                                </th>
                                {!typeWarehouseExternal &&
                                  method !== 'cross_dock' && (
                                    <th className="p-2 text-end align-middle">
                                      Status COA
                                    </th>
                                  )}
                                <th className="p-2 text-end align-middle">
                                  Batch
                                </th>
                                <th className="p-2 text-end align-middle">
                                  Receiving
                                </th>
                                <th className="p-2 text-end align-middle">
                                  Base Uom Qty
                                </th>
                                <th className="p-2 text-end align-middle">
                                  COA Document
                                </th>
                                <th className="p-2 text-end align-middle">
                                  COA MD
                                </th>
                                <th className="p-2 text-end align-middle">
                                  COA ED
                                </th>
                                <th className="p-2 text-end align-middle">
                                  Label MD
                                </th>
                                <th className="p-2 text-end align-middle">
                                  Label ED
                                </th>
                                {typeWarehouseExternal && (
                                  <>
                                    <th className="p-2 text-end align-middle">
                                      Destination Area
                                    </th>
                                    <th className="p-2 text-end align-middle">
                                      Problem
                                    </th>
                                    <th className="p-2 text-end align-middle">
                                      Remark
                                    </th>
                                  </>
                                )}
                                <th className="p-2 text-end align-middle">
                                  Action
                                </th>
                              </tr>
                            </thead>
                            <tbody>
                              {itemCoas.map((item, i) => {
                                return (
                                  <>
                                    <tr key={i}>
                                      <td className="p-2 align-middle">
                                        {i + 1}
                                      </td>
                                      <OverlayTrigger
                                        trigger={['hover', 'click']}
                                        key={'bottom'}
                                        placement={'bottom'}
                                        overlay={
                                          <Popover
                                            id={`popover-positioned-bottom`}
                                          >
                                            <Popover.Body>
                                              <p className="text-center fw-bold text-uppercase">
                                                item name
                                              </p>
                                              <p className="text-center">
                                                {item?.items?.item_name}
                                              </p>
                                              <p className="text-center fw-bold text-uppercase">
                                                item code
                                              </p>
                                              <p className="text-center">
                                                {item?.items?.item_code}
                                              </p>
                                            </Popover.Body>
                                          </Popover>
                                        }
                                      >
                                        <td className="p-2 align-middle">
                                          <Row>
                                            <Col md={12}>
                                              {item?.items?.item_name}
                                            </Col>
                                            {item?.items?.has_category === 0 ? (
                                              <Col md={12}>
                                                <small
                                                  className="text-danger fw-bold"
                                                  onClick={() =>
                                                    handleAddCategory(
                                                      item.items
                                                    )
                                                  }
                                                  style={{
                                                    cursor: 'pointer'
                                                  }}
                                                >
                                                  ! Uncategorized Item
                                                </small>
                                              </Col>
                                            ) : null}
                                          </Row>
                                        </td>
                                      </OverlayTrigger>
                                      {!typeWarehouseExternal &&
                                        method !== 'cross_dock' && (
                                          <td className="p-2 text-end align-middle">
                                            <Badge pill bg="secondary">
                                              UNCHECKED
                                            </Badge>
                                          </td>
                                        )}
                                      <td className="p-2 text-end align-middle">
                                        {item?.batch?.batch}
                                      </td>
                                      <td className="p-2 text-end align-middle">
                                        {item?.total_pack}{' '}
                                        {item?.conversion_uom}
                                      </td>
                                      <td className="p-2 text-end align-middle">
                                        {item?.total_qty}{' '}
                                        {item?.items?.uom?.conversion_qty_uom}
                                      </td>
                                      <td className="p-2 text-end align-middle text-primary">
                                        {item?.document_name ? (
                                          <Button
                                            variant="transparent"
                                            className="text-primary download-coa-pr"
                                            onClick={() => {
                                              handleDownloadDocumentCoa(
                                                item?.batch?.id || item?.id,
                                                item?.document_id
                                              )
                                            }}
                                          >
                                            {item?.document_name}
                                          </Button>
                                        ) : (
                                          (item?.coa?.name ?? '-')
                                        )}
                                      </td>
                                      <td className="p-2 text-end align-middle">
                                        {item.coa_pd
                                          ? convertDateWithoutTime(item.coa_pd)
                                          : '-'}
                                      </td>
                                      <td className="p-2 text-end align-middle">
                                        {item.coa_ed
                                          ? convertDateWithoutTime(item.coa_ed)
                                          : '-'}
                                      </td>
                                      <td className="p-2 text-end align-middle">
                                        {typeWarehouseExternal ||
                                        method === 'cross_dock'
                                          ? item.label_pd &&
                                            item.label_pd !== ''
                                            ? convertDateWithoutTime(
                                                item.label_pd
                                              )
                                            : '-'
                                          : '-'}
                                      </td>
                                      <td className="p-2 text-end align-middle">
                                        {typeWarehouseExternal ||
                                        method === 'cross_dock'
                                          ? item.label_ed &&
                                            item.label_ed !== ''
                                            ? convertDateWithoutTime(
                                                item.label_ed
                                              )
                                            : '-'
                                          : '-'}
                                      </td>
                                      {typeWarehouseExternal && (
                                        <>
                                          <td className="p-2 text-end align-middle">
                                            <Select
                                              menuPortalTarget={document.body}
                                              cacheOptions
                                              options={areaOptions}
                                              onMenuOpen={() => {
                                                setItemCoaIdValue(item?.id)
                                              }}
                                              onMenuClose={() => {
                                                setItemCoaIdValue(null)
                                              }}
                                              onChange={(e) =>
                                                handleChangeItemCoa(
                                                  'area_id',
                                                  item?.id,
                                                  e
                                                )
                                              }
                                            />
                                          </td>
                                          <td className="p-2 text-end align-middle">
                                            <Form.Select
                                              aria-label="select-problem"
                                              onChange={(e) =>
                                                handleChangeItemCoa(
                                                  'problem',
                                                  item?.id,
                                                  e.target.value || ''
                                                )
                                              }
                                              disabled={
                                                !item.area_id ||
                                                item.area_id.code === 'UT'
                                              }
                                              value={item?.problem || ''}
                                            >
                                              {item?.coa_pd ===
                                                item?.label_pd &&
                                              item?.coa_ed ===
                                                item?.label_ed ? (
                                                <>
                                                  <option>
                                                    Select Problem
                                                  </option>
                                                  <option value="bocor">
                                                    Bocor
                                                  </option>
                                                  <option value="tidak_ada_label">
                                                    Tidak Ada Label
                                                  </option>
                                                  <option value="tidak_ada_segel">
                                                    Tidak Ada Segel
                                                  </option>
                                                </>
                                              ) : (
                                                <option value="coa_not_match">
                                                  COA NOT MATCH
                                                </option>
                                              )}
                                            </Form.Select>
                                          </td>
                                          <td className="p-2 text-end align-middle">
                                            <Form.Control
                                              type="text"
                                              placeholder="Ketik Keterangan"
                                              value={item?.remark || ''}
                                              onChange={(e) =>
                                                handleChangeItemCoa(
                                                  'remark',
                                                  item?.id,
                                                  e.target.value || ''
                                                )
                                              }
                                              disabled={
                                                !item.area_id ||
                                                item.area_id.code === 'UT'
                                              }
                                            />
                                          </td>
                                        </>
                                      )}
                                      <td className="p-2 text-end align-middle">
                                        <div className="d-flex flex-row gap-2 justify-content-end">
                                          <div className="d-flex flex-column justify-content-center">
                                            <CircleAlert
                                              size={16}
                                              className="text-danger me-2"
                                              hidden={
                                                (item.coa_pd ===
                                                  item.label_pd &&
                                                  item.coa_ed ===
                                                    item.label_ed) ||
                                                method === 'cross_dock'
                                              }
                                            />
                                          </div>
                                          <button
                                            className="btn btn-secondary ml-2"
                                            type="button"
                                            onClick={() =>
                                              handleUpdateItemCoa(item)
                                            }
                                          >
                                            <SquarePen size={14} />
                                          </button>
                                          <button
                                            type="button"
                                            className="btn btn-danger ml-2"
                                            onClick={() =>
                                              onDeleteItemCoa(item)
                                            }
                                          >
                                            <Trash2 size={14} />
                                          </button>
                                        </div>
                                      </td>
                                    </tr>
                                  </>
                                )
                              })}
                            </tbody>
                          </Table>
                        )}
                      </Col>
                    </Row>
                  </Card.Body>
                </Card>
                {/* ATTACHMENT */}
                {(typeWarehouseExternal || method === 'cross_dock') && (
                  <Card style={cardStyle}>
                    <Card.Header className="bg-white border-0 pt-3 pb-0 ps-0">
                      <h5 className="text-secondary fw-bold text-uppercase">
                        attachment <sup style={{ color: 'red' }}>*</sup>
                      </h5>
                    </Card.Header>
                    <Card.Body className="px-0">
                      <Row>
                        <Col md={12}>
                          <div
                            style={{
                              border: `1px dashed ${
                                isDragging ? 'gray' : '#C9CACD'
                              }`,
                              height: '80px'
                            }}
                            onDragOver={handleDragOver}
                            onDragLeave={handleDragLeave}
                            onDrop={handleDrop}
                          >
                            <div className="d-flex flex-column justify-content-center p-2 h-100">
                              <div className="d-flex flex-row justify-content-center gap-2">
                                <input
                                  type="file"
                                  id="upload-file-attachment"
                                  className="d-none"
                                  ref={uploadFileAttachment}
                                  onChange={(e) =>
                                    handleChangeUploadAttachment(e)
                                  }
                                  accept="application/pdf"
                                />
                                <Button
                                  style={btnOrange}
                                  onClick={() =>
                                    uploadFileAttachment.current?.click()
                                  }
                                  className="text-uppercase fw-bold"
                                >
                                  Browse
                                </Button>
                                <div
                                  className="d-flex flex-column justify-content-center align-items-center h-100"
                                  style={{ fontSize: '13px' }}
                                >
                                  Or Drop pdf files here
                                </div>
                              </div>
                            </div>
                          </div>
                        </Col>
                      </Row>
                      {uploadingAttachment && (
                        <Row className="mt-3">
                          <Col md={5}>
                            <div
                              className="d-flex align-items-center gap-2 p-3 rounded shadow-sm"
                              style={{ border: '0.5px solid #E3E3E3' }}
                            >
                              <Spinner animation="border" size="sm" />
                              <span style={{ fontSize: '13px' }}>
                                Uploading attachment...
                              </span>
                            </div>
                          </Col>
                        </Row>
                      )}
                      {attachments.length > 0 && (
                        <Row className="mt-3">
                          <Col md={5}>
                            <div className="d-flex flex-column gap-3">
                              {attachments.map((attachment, index) => (
                                <div
                                  className="d-flex justify-content-between px-2 py-3 rounded shadow-sm"
                                  style={{ border: '0.5px solid #E3E3E3' }}
                                  key={`attachment-${index}`}
                                >
                                  <span className="fs-6 mt-2 ms-2">
                                    {attachment?.name || ''}
                                  </span>

                                  <button
                                    type="button"
                                    className="btn btn-secondary me-3"
                                    onClick={() =>
                                      handleRemoveUploadAttachment(
                                        Number(index)
                                      )
                                    }
                                  >
                                    <Trash2 size={14} />
                                  </button>
                                </div>
                              ))}
                            </div>
                          </Col>
                        </Row>
                      )}
                    </Card.Body>
                  </Card>
                )}
                {/* BUTTON */}
                {isLoading ? (
                  <Loader />
                ) : (
                  <Row>
                    <Col xs={6} md={6} lg={6}>
                      <Button
                        className="text-danger"
                        type="button"
                        variant="link"
                        style={{ textDecoration: 'none' }}
                        onClick={() => {
                          Swal.fire({
                            title: 'Cancel creating ticket?',
                            text: 'Draft will be discarded',
                            icon: 'warning',
                            allowOutsideClick: false,
                            showCancelButton: true,
                            confirmButtonColor: '#d33',
                            cancelButtonText: 'Continue creating',
                            confirmButtonText: 'Discard'
                          }).then((result) => {
                            if (result.isConfirmed) {
                              navigate('/purchase-order')
                            }
                          })
                        }}
                      >
                        Cancel
                      </Button>
                    </Col>
                    <Col xs={6} md={6} lg={6} className="text-end">
                      <CustomButton
                        onClick={handleSubmit}
                        type="submit"
                        variant={variantButtonSubmit(dirty, isValid)}
                        disabled={
                          variantButtonSubmit(dirty, isValid) === 'secondary'
                            ? true
                            : false
                        }
                        text={'Save'}
                      />
                    </Col>
                  </Row>
                )}
              </Form>
            )
          }}
        </Formik>
      </Container>

      <ModalUpdateVehiclePrDraft
        show={modalUpdateShow}
        onHide={() => setModalUpdateShow(false)}
        selectedVehicle={selectedVehicle}
        updateVehicleInList={updateVehicleInList}
      />

      <ModalAddBatch
        show={modalAddBatch}
        onHide={() => setModalAddBatch(false)}
        item={selectItem}
        batch={inputBatch}
        setBatchId={setBatchId}
        setInputBatch={setInputBatch}
        refreshData={() => refBatch.current?.clear()}
      />

      <ModalUpdateItemCoaPrDraft
        show={modalUpdateItemShow}
        onHide={() => setModalUpdateItemShow(false)}
        method={method}
        selecteditemcoa={selectedItemCoa}
        typeWarehouseExternal={typeWarehouseExternal}
        updateitemcoasinlist={updateItemCoasInList}
      />

      <ModalAddCategoryItem
        show={modalAddCategory}
        onHide={() => setModalAddCategory(false)}
        code={listItemsId.id}
        name={listItemsId.name}
        refreshData={() => {
          loadItems()
        }}
      />

      <ModalCheckSuggest
        show={suggest.show}
        onHide={() => setSuggest({ ...suggest, show: false })}
        data={suggest.itemCodes || []}
      />
    </>
  )
}

export default PurchaseReceiptCreate
